<div class="action-conatiner p-5 white-bg">
    <div class="action-header">
        <h4 class="bold-text primary-text">{{alertVarService.titles.templateTitles.update_action.action}}</h4>
    </div>

    <div class="action-body" [formGroup]="updateAction">
        <div class="action-body-row-1 pl-4">
            <div class="options">
                <div class="title"> 
                    <ng-container *ngFor="let alertStatus of alertActionMetadata.states.status|keyvalue:originalOrder">
                        <span class="action-status-text content-l px-2 py-1 radius-xl" *ngIf="alertStatus.key != '0'"
                            [ngClass]="alertStatus.key === selected_status ? 'border-report' : 'chips-default'"
                            (click)="select_status(alertStatus.key)">{{alertStatus.value.disp}}</span>
                    </ng-container>
                </div>
                <ng-container *ngIf="selected_status == '1'">
                    <div class="assignUser">
                        <h5 class="bold-text primary-text">{{alertVarService.titles.templateTitles.update_action.assign_to}}</h5>
                        <app-overlay-select [formControl]="selectedUser" [data]="UserList"
                            [style]="{'font-size':'12px','background':'transparent'}">
                        </app-overlay-select>
                    </div>
                </ng-container>
            </div>
            <div class="classifications">
                <div class="action-body-row-1-col-1 p-2 border-light-right">

                    <ng-container
                        *ngFor="let alertCategory of alertActionMetadata.states.status[selected_status]?.state|keyvalue:originalOrder">
                        <span class="list-item py-2 content-m enable-action"
                            [ngClass]="alertCategory.key === selected_category ? 'selectable-text' : ''"
                            (click)="select_category(alertCategory.key)">{{alertCategory.value.disp}}</span>
                    </ng-container>
                </div>
                <div class="action-body-row-1-col-2 p-2 border-light-right">

                    <ng-container
                        *ngFor="let alertSubCategory of alertActionMetadata.states.status[selected_status]?.state[selected_category].category|keyvalue:originalOrder">
                        <span class="list-item py-2 content-m enable-action"
                            [ngClass]="alertSubCategory.key === selected_subcategory ? 'selectable-text' : ''"
                            (click)="select_subcategory(alertSubCategory.key)">{{alertSubCategory.value.disp}}</span>
                    </ng-container>
                </div>
                <div class="action-body-row-1-col-3 p-2">
                    <ng-container
                        *ngFor="let alertReason of alertActionMetadata.states.status[selected_status]?.state[selected_category]?.category[selected_subcategory]?.reason|keyvalue:originalOrder">
                        <span class="list-item py-2 content-m enable-action"
                            [ngClass]="alertReason.key === selected_reason ? 'selectable-text' : ''"
                            (click)="select_reason(alertReason.key)">{{alertReason.value.disp}}</span>
                        <h5 *ngIf="alertReason.key === selected_reason && alertReason.value.value == 'others'"
                            class="bold-text primary-text py-2">{{alertVarService.titles.templateTitles.update_action.comments}}</h5>
                        <textarea *ngIf="alertReason.key === selected_reason && alertReason.value.value == 'others'"
                            class="input-border border-light primary-bg" type="text"
                            formControlName="comments"></textarea>

                    </ng-container>

                </div>
            </div>
        </div>
        <ng-container *ngIf="updateActionSpinnerState">
            <div class="action-update-spinner dropdown-shadow">
                <mat-spinner class="spinner" diameter=20></mat-spinner>
            </div>
        </ng-container>
    </div>
    <div class="alert-danger alert-text span-s">
        <div *ngIf="error_status">
            {{error_msg}}
            <!-- {{customer_metadata_infos.error.platforms|oneError: platforms.errors}} -->
        </div>
        <div *ngIf="comments.errors?.maxlength">Content cannot exceed {{limit}} characters.</div>
    </div>
    <div class="action-footer">
        <div class="action-status">
            <!-- <span class="checkbox-container">
                <input type="checkbox" [formControl]="actRemove">
                <span class="checkmark"></span>
            </span> -->
            <!-- <span class="label">Remove alerts after action</span> -->
        </div>
        <div class="footer-buttons">
            <button class="cancel" (click)="cancelAction()">{{alertVarService.titles.templateTitles.update_action.cancel}}</button>
            <button class="submit" [ngClass]="comments.errors? 'pagination-disable':'enable-action'" (click)="
                submitAction()">{{alertVarService.titles.templateTitles.update_action.submit}}</button>
        </div>
    </div>
</div>